<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
    [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
    [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
    [rowHover]="true" [showCurrentPageReport]="true" dataKey="name"
    currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
    styleClass="p-datatable-striped">

    <!-- #region TABLE TITLE DEFINITION -->
    <ng-template pTemplate="caption">
        <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            {{ 'tableManagement.breakdown.title' | translate }}
        </div>
    </ng-template>
    <!-- #endregion TABLE TITE DEFINITION -->

    <!-- #region TABLE COLUMN DEFINITION -->
    <ng-template pTemplate="header">
        <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            <!-- VEHICLE -->
            <th pSortableColumn='vehicle.name'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'general.vehicle' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='vehicle.name'></p-sortIcon>
                        <p-columnFilter field='vehicle' type='text' matchMode='contains'
                            placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
                            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- DRIVER -->
            <th pSortableColumn='driver.employee.user.surname1'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.sinister.driver' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='driver.employee.user.surname1'></p-sortIcon>
                        <p-columnFilter field='driver' type='text' matchMode='contains'
                            placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
                            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- START DATE WORKSHOP -->
            <th pSortableColumn='startDateWorkshop'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.sinister.workshopStartDate' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='startDateWorkshop'></p-sortIcon>
                        <p-columnFilter field='startDateWorkshop' type='date' matchMode='contains'
                            placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
                            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- END DATE WORKSHOP -->
            <th pSortableColumn='endDateWorkshop'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.sinister.workshopEndDate' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='endDateWorkshop'></p-sortIcon>
                        <p-columnFilter field='endDateWorkshop' type='date' matchMode='contains'
                            placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
                            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- BREAKDOWN REASON -->
            <th pSortableColumn='breakdownReason.reason'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.breakdown.breakdownReason.reason' | translate }}
                    </div>

                     <!-- COLUMN SORT && FILTER ICONS -->
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="breakdownReason.reason"></p-sortIcon>
                        <p-columnFilter field="breakdownReason" type="text" matchMode="contains"
                            placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- CLOSED -->
            <th pSortableColumn='closed'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'tableManagement.breakdown.closed' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='closed'></p-sortIcon>
                        <p-columnFilter field='closed' type='boolean' display='menu'
                            [showApplyButton]="false"></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- DELETE -->
			<th class="button-column"></th>

        </tr>
    </ng-template>
    <!-- #endregion TABLE COLUMN DEFINITION -->

    <!-- #region TABLE BODY -->
    <ng-template pTemplate="body" let-breakdown>
        <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="openDialog(breakdown)">

            <!-- VEHICLE -->
            <td>
                {{ breakdown.vehicle.name }}
            </td>

            <!-- DRIVER -->
            <td>
                {{ breakdown.driver?.employee?.user?.surname1}} {{ breakdown.driver?.employee?.user?.surname2}},  {{breakdown.driver?.employee.user?.name }}
            </td>

            
            <!-- START DATE WORKSHOP -->
            <td>
                {{ breakdown.startDateWorkshop | date: 'dd/MM/yyyy' }}
            </td>

            <!-- END DATE WORKSHOP -->
            <td>
                {{ breakdown.endDateWorkshop | date: 'dd/MM/yyyy' }}
            </td>

            <!-- BREAKDOWN REASON -->
            <td>
                {{ breakdown.breakdownReason.reason }}
            </td>

            <!-- CLOSED -->
            <td [ngStyle]="{ 'background-color': breakdown.closed ? 'red' : 'green' }">          
            </td>


            <!-- DELETE -->
			<td class="button-column">
				@if (isDeleteGranted) {
				<button type="button" class="btn custom-table-remove-button" (click)="onDeleteBreakdown(breakdown)">
					<svg-icon
						src="assets/icons/trash.svg"
						class="d-flex flex-wrap custom-table-remove-button-icon"
						[svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
					></svg-icon>
				</button>
				}
			</td>
        </tr>

    </ng-template>
    <!-- #endregion TABLE BODY -->

    <!-- #region TABLE EMPTY MESSAGE -->
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8" class="p-0">
                <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE EMPTY MESSAGE -->

    <!-- #region TABLE FOOTER -->
    <ng-template pTemplate="footer">
        <tr>
            <td colspan="8" class="p-0">
                <div class="d-flex flex-row align-items-center p-3 gap-3">

                    <!-- ADD accessory BUTTON -->

                    @if (isCreateGranted) {
                    <app-table-add-button [text]=" 'tableManagement.breakdown.title' | translate"
                        (btnClick)="create()"></app-table-add-button>
                    }
                   
                    

                    <!-- EXCEL BUTTON -->
                    <app-table-excel-button class="buttonTableExcel"  (btnClick)="exportExcel()"></app-table-excel-button>
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE FOOTER -->

</p-table>

<!-- BREAKDOWN FORM -->
<app-breakdown-form [vehicle]="vehicle"></app-breakdown-form>

<p-confirmDialog
	#saveEventDialog
	[header]="'confirm.critic' | translate"
	[message]="'control-panel.delete-dialog.message' | translate"
	class="custom-dialog"
	icon="pi pi-exclamation-triangle"
	key="breakdown-list"
>
	<ng-template pTemplate="footer">
		<!-- REJECT BUTTON -->
		<button (click)="saveEventDialog.onReject()" class="custom-button">
			{{ 'general.no' | translate }}
		</button>
		<!-- ACCEPT BUTTON -->
		<button (click)="saveEventDialog.onAccept()" class="custom-button">
			{{ 'general.yes' | translate }}
		</button>
	</ng-template>
</p-confirmDialog>
